import styled, {css} from 'styled-components';
import { DataValue } from "../../../../CommonComponents/commonStyles";

const commonFontStyles = css`
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.primary};
    letter-spacing: 0.5px;
    color: ${props => props.theme.fontColors.textColor};
`

export const TabName = styled.span`

`

export const TabsWrap = styled.div`
    .ant-tabs-extra-content {
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            float: unset !important;
        }
    }
    .ant-tabs-bar {
        border-bottom: 1px solid #e8e8e8 !important;
    }
    .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
        height: 55px;
        padding: 0 20px;
        margin-right: 0;
        border-radius: 0;
        line-height: 47px;
        background: #f4f3f3;
        ${commonFontStyles};
        border-top: 4px solid rgba(0, 103, 120, 0.1);
        border-bottom: 0;
        border-left: 1px solid rgba(212, 212, 212, 0.9);
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            height: 43px !important;
            font-size: ${props => props.theme.fontSize.secondary} !important;
            line-height: 1;
            padding: 14px 15px 14px 15px !important;
        }
    }
    .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container{
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            height: 43px !important;
        }
    }
    .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
        height: 56px;
        ${commonFontStyles};
        color: ${props => props.theme.fontColors.primary};
        background: ${props => props.theme.backgroundColor.layoutLight};
        border-top: 4px solid ${props => props.theme.border.teal};
    }
`

export const ExportPrint = styled.span`
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.fontColors.primary};
    text-decoration: underline;
    cursor: pointer;
    margin-right: ${props => props.marginRight};
    @media only screen and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.secondary};
    }
`

export const IconWrap = styled.div`
display: flex;
    i {
        svg {
            width: 27px;
            height: 18px;
        }
    }
    margin-right: ${props => props.marginRight};
`

export const ExtraContentWrap = styled.div`
    padding-top: 12px;
    display: flex;
    align-items: center;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding: 0px 20px 20px 20px;
    }
`

export const ExtraBalWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 15px;
    margin-right: 4px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        padding-top: 0;
        padding-bottom: 0px;
        justify-content: flex-start;
    }
`

export const DisplayFlex = styled.div`
    display: flex;
    align-items: center;
`
export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  @media (max-width: 990px) {
    margin-left: 0px;
    margin-right: 26px;
  }
`
export const DataExportPrint = styled(DataValue)`
  margin: 0px 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};  
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero}; 
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: block;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  a{
    color: ${props => props.theme.colors.primaryColor}
    letter-spacing: ${props => props.theme.letterSpacing.zero};
  }
`
export const Print = styled.div`
    top: 70px;
    right: 32%;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        top: 30px;
        right: 10px; 
    }
`